import { Component, OnInit, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { countryOfBusiness } from 'src/app/_data/country-states';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss']
})
export class PhoneInputComponent implements ControlValueAccessor {

  constructor(
    @Self() public ngControl: NgControl
  ) { 
    this.ngControl.valueAccessor = this
  }

  /** The flag in front of the number follows the business's country (Pakistan or the US). */
  get flagSrc(): string {
    const country = countryOfBusiness(GlobalService.userInfo?.businessSetup?.[0], GlobalService.countryCode);
    return country === 'PK' ? 'assets/images/pk-flag-icon.svg' : 'assets/images/us-flag-icon.png';
  }

  writeValue(obj: any): void {
    // throw new Error('Method not implemented.');
  }
  registerOnChange(fn: any): void {
    // throw new Error('Method not implemented.');
  }
  registerOnTouched(fn: any): void {
    // throw new Error('Method not implemented.');
  }
  setDisabledState?(isDisabled: boolean): void {
    // throw new Error('Method not implemented.');
  }

}
